import { BankAccountFormData } from "@/formTypes/BankAccountFormDataType";
import { GenericModelApi } from "./GenericModelApi";
import { ApiSchema } from "./ApiClient";

export type BankAccountDataType = Partial<ApiSchema["BankAccount"]["type"] & BankAccountFormData>;
export const BankAccountApi = new GenericModelApi<"BankAccount", BankAccountDataType>("BankAccount", "title");